function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Skeleton, Image, Space, Statistic } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import Common from "../../components/includes/Common";
import { AwardFill } from "react-bootstrap-icons";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ContestMilestoneReport = function ContestMilestoneReport(_ref) {
  var milestone_id = _ref.milestone_id;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    milestone = _useState2[0],
    setMilestone = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    candidates = _useState4[0],
    setCandidates = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataLoading = _useState6[0],
    setIsDataLoading = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    errorMessage = _useState8[0],
    setErrorMessage = _useState8[1];
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getcontestmilestoneresult/" + milestone_id + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setCandidates(response.data.candidates);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsx(Container, {
    children: isDataLoading ? /*#__PURE__*/_jsx(Skeleton, {
      active: true
    }) : /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Space, {
        direction: "vertical",
        children: candidates.map(function (c) {
          return /*#__PURE__*/_jsxs(Space, {
            style: {
              borderTop: "1px solid #F4EEED",
              marginTop: "12px"
            },
            direction: "horizontal",
            children: [/*#__PURE__*/_jsx(Image, {
              preview: false,
              src: c.cover_url,
              width: "100px",
              style: {
                borderRadius: "7px"
              }
            }), /*#__PURE__*/_jsxs(Space, {
              direction: "vertical",
              children: [/*#__PURE__*/_jsx("h6", {
                children: /*#__PURE__*/_jsx("b", {
                  children: c.name
                })
              }), /*#__PURE__*/_jsx(Statistic, {
                title: "Total votes",
                value: c.vote_count,
                prefix: /*#__PURE__*/_jsx(AwardFill, {})
              })]
            })]
          }, c.id);
        })
      })
    })
  });
};
export default ContestMilestoneReport;